module.exports = __webpack_public_path__ + "static/img/fuzhiIcon.a04ee12d.svg";